import { useState } from "react";
import useDeviceSize from "hooks/useDeviceSize";
import chunk from "lodash/chunk";
import "keen-slider/keen-slider.min.css";
import { Box, Flex, HStack } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { useKeenSlider } from "keen-slider/react";
import { Dots } from "modules/common/components/Trustpilot/Dots";
import type { APRCardsProps, APRCardProps } from "./APRCards.d";
import { APRCard } from "./APRCard";

export const APRCards = ({ cards, sbEditable }: SbEditableComponentProps<APRCardsProps>) => {
  const { isMobile, isDesktop, isDesktopXl } = useDeviceSize();
  const [currentSlide, setCurrentSlide] = useState(0);

  const [sliderRef, instanceRef] = useKeenSlider({
    mode: "snap",
    slides: {
      origin: isDesktop || isDesktopXl ? "center" : "auto",
      perView: "auto",
    },
    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
  });

  const chunkedCards: Array<APRCardProps[]> = isDesktop ? chunk(cards, 3) : chunk(cards, 2);

  const numberOfSlides: number = isMobile ? cards.length : chunkedCards.length;

  const goToSlide = (slideIndex: number) => instanceRef.current?.moveToIdx(slideIndex);

  const mobileSlider = cards.map((card) => (
    <Flex className="keen-slider__slide" key={card.title} minW="fit-content" maxW="fit-content">
      <HStack spacing={5} align="stretch" px={5}>
        <APRCard {...card} />
      </HStack>
    </Flex>
  ));

  const chunkedCardsSlider = chunkedCards.map((cards) => (
    <Flex className="keen-slider__slide" key={cards[0].title} minW="fit-content" maxW="fit-content">
      {cards.map((card) => (
        <Flex key={card.imgSrc} px={5}>
          <APRCard {...card} />
        </Flex>
      ))}
    </Flex>
  ));

  return (
    <>
      <Box ref={sliderRef} className="keen-slider" {...sbEditable}>
        {isMobile ? mobileSlider : chunkedCardsSlider}
      </Box>
      <Flex mx={4} justifyContent={{ base: "flex-start", md: "center" }}>
        <Dots currentSlide={currentSlide} numberOfSlides={numberOfSlides} goToSlide={goToSlide} color="primary.500" />
      </Flex>
    </>
  );
};
